jQuery.noConflict();
(function( $ ) {
    $(function() {
    //Document Ready STARTS

        var wdata = [];
        wdata.mobileWidth = 640;
        wdata.debug = false;
        wdata.afterLoad = false;
        wdata.prevScrollTop = 0;
        wdata.scrollTop = 0;
        wdata.swiper = []
        wdata.hoverLinkAnimating = false;

        //PLACEHOLDERS
        $('input, textarea').placeholder(); //add placeholders for load browsers

        // Improved multi-select boxes
        $('.content select[multiple]').multipleSelect();

        $(window).on('load', function(){
            afterLoad();
        });

        function afterLoad() {
            svgSupport();
            updateWData();
            runSwiper();
            lazyBg();
            useLargeImages();
            initVideoJS();
            layoutBlockVis();
            removeSplash();
            bindClick();
            setupAutoComplete();
            shopLayoutToggle();
            bindIntMap();
            initVacanciesSearch();
            $('.mobile-nav').attr('style', '');
            updateBodyContrasdtAndFont();
            hadleBodyControls();
            videoJSHeight();
            wdata.afterLoad = true;

        }

        setTimeout(function(){
            if (wdata.afterLoad == false) {
                afterLoad();
            }
            $(window).trigger('resize');
          //  forcePop();
            ariaFix();
        }, 2500);

        function ariaFix(){
            $('#menu-mobile').removeAttr('aria-multiselectable');
        }

        // Functions On Window resize
        $(window).on('resize', function(){
            updateWData();
            lazyBg();
            layoutBlockVis();
            videoJSHeight();
            adjustVideoHeight();
        });

        // Window scroll
         $(window).on('scroll', function(){
             wdata.prevScrollTop = wdata.scrollTop;
             wdata.scrollTop = $(window).scrollTop();
             lazyBg();
             layoutBlockVis();
        });

        // mobile mnu toggle functions
        $('.hamburger').on('click', function(e){
            e.preventDefault();
            $(this).toggleClass('is-active');
            $('.mobile-nav').toggleClass('active');
            $('body').toggleClass('scroll-lock');
        });

        $('.menu-close .close-menu').on('click', function(e){
            e.preventDefault();
            $('.hamburger').toggleClass('is-active');
            $('.mobile-nav').toggleClass('active');
            $('body').toggleClass('scroll-lock');
        });

        //Adjust Header spacer height
        function spacerHeight() {
            var headerHeight = $('.header').outerHeight();
            $('.header-spacer').height(headerHeight);
        }

        $('.hover-link-trigger > a').on('mouseover', function(e){
            var triggerId = $(this).attr('data-hover'),
                currentActive = $(this).parents('.fc-row').find('.hover-content:visible').attr('id');
            if (triggerId != currentActive && wdata.hoverLinkAnimating == false) {
                wdata.hoverLinkAnimating = true;
                $('#'+triggerId).slideToggle();
                $('#'+currentActive).slideToggle();
                setTimeout(function(){
                    wdata.hoverLinkAnimating = false;
                }, 500);
            }
        });

        //Check if DOM has MAP
        if(($('#map').data('lat') != '') && ($('#map').data('lat') != undefined)) {
            initMap();
        }

        $('.evs-filters-toggle').on('click', function(e){
            e.preventDefault();
            $('body').toggleClass('scroll-lock');
            $('.evs-sidebar').toggleClass('mobile-active');
        });

        $('.mobile-filter-close').on('click', function(){
            $('.evs-filters-toggle').trigger('click');
        });

        function removeSplash() {
            $( '.splishs-plash-splosh').fadeTo( 'fast' , 0.1, function() {
                $( '.splishs-plash-splosh').remove();
            });
        }

       /* Run sliders */
        function runSwiper(){
            var centerSlides = false;
            var starSlide = 0;
            if (wdata.ww < wdata.mobileWidth) {
                centerSlides = true;
                starSlide = 1;
            }
            else {
                $.each($('.videos-sw-slider'), function(e){
                    var sliderId = $(this).attr('id');
                  //  console.log(sliderId);
                    $('#'+sliderId+' .swiper-wrapper').prepend('<div class="swiper-slide desktop-empty"></div>');
                });
            }
            $.each($('.sw-wrap .swiper-container'), function(e){
                var sliderId = $(this).attr('id'),
                    rowId = $(this).attr('data-id');
              //  console.log(sliderId +'ss');
                if (sliderId != undefined && sliderId != '') {
                    wdata.swiper[sliderId] = new Swiper('#'+sliderId, {
                        slidesPerView: 'auto',
                        centeredSlides: centerSlides,
                        initialSlide: starSlide,
                        spaceBetween: 0,
                        navigation: {
                            nextEl: '.next-'+rowId,
                            prevEl: '.prev-'+rowId,
                        },
                        keyboard: {
                            enabled: true,
                            onlyInViewport: true,
                        },
                    });
                }
            });

            if ($('.logos-slider').length>0) {
                var logosSlider = new Swiper('.logos-slider', {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    speed: 800,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                    loop: true,
                    loopFillGroupWithBlank: true,
                    pagination: {
                        clickable: true,
                    },
                });
            }

            if ($('.images-slider').length>0) {
                var imagesSlider = new Swiper('.images-slider', {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    speed: 800,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                    loop: true,
                    loopFillGroupWithBlank: true,
                    pagination: {
                        clickable: true,
                    },
                });
            }

            if ($('.header-slider').length>0) {
                $.each($('.header-slider'), function(){
                    var sliderId = $(this).attr('id'),
                        rowId = $(this).attr('data-id'),
                        menuName = 'sliderMenu'+rowId,
                        menu = window[menuName];
                  //  console.log(menu);
                    wdata.swiper[sliderId] = new Swiper('#'+sliderId, {
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        speed: 800,
                        navigation: {
                            nextEl: '.next-'+rowId,
                            prevEl: '.prev-'+rowId,
                        },
                        keyboard: {
                            enabled: true,
                            onlyInViewport: true,
                        },
                        pagination: {
                            el: '#'+sliderId+' .swiper-pagination',
                            clickable: true,
                            renderBullet: function (index, className) {
                                return '<span class="' + className + ' '+ (menu[index]['colour']) +'" data-link="'+ (menu[index]['link']) +'" data-index="'+index+'" data-sid="'+sliderId+'">' + (menu[index]['title']) + '</span>';
                            },
                        },
                        loop: true,
                        loopFillGroupWithBlank: true,
                    });

                    // Simulate click on pagination hover
                    var $container = $(this);
                    setTimeout(function() {
                        $container.find('.swiper-pagination-bullet').mouseenter(function() {
                            var sliderId = $(this).attr('data-sid'),
                                slideIndex = $(this).attr('data-index');
                            if (sliderId != undefined && slideIndex != undefined) {
                              //  console.log('#'+sliderId +' index: '+slideIndex);
                                wdata.swiper[sliderId].slideTo(slideIndex);
                            }
                        });
                    }, 500);
                });

                $('.header-slider .swiper-pagination-bullet').on('click', function(){
                    var link = $(this).attr('data-link');
                    if (link != undefined && link != '') {
                        window.location.href = link;
                    }
                });
            }

            setTimeout(function(){
                $('.desktop  .header-slider .swiper-pagination-bullet').on('hover', function(){
                    $(this).trigger('click');
                //    console.log('zz');
                });
            }, 800);
        }

        function initVideoJS(){
            $.each($('video.video-js'), function(){
                var videoId  = $(this).attr('id');
                var player = videojs(videoId);
            });
        }

        function adjustVideoHeight(){
            if ( $('.video-container.with-chat').length > 0 ) {
                var maxAllowedHeight = wdata.wh;
                if (maxAllowedHeight > 480) {
                    $.each($('.video-container.with-chat'), function(){
                        var possibleVideoHeight = $(this).find('.video-wrap').height() - 16;
                        if (possibleVideoHeight < maxAllowedHeight) {
                            $(this).find('#nodechat').css('height', (possibleVideoHeight) + 'px');
                            $(this).find('.chat-wrap').css('height', possibleVideoHeight + 'px');
                        }
                        else {
                            $(this).find('#nodechat').css('height', (possibleVideoHeight) + 'px');
                            $(this).find('.chat-wrap').css('height', possibleVideoHeight + 'px');
                        }
                    });
                }
            }
        }

        $('.play-video').on('click', function(e){
            e.preventDefault();
            var link = $(this).attr('href');
            var windowWidth = $(window).width(),
                width = windowWidth * 0.8,
                height = width * 0.5625,
                html = '<div class="pop-vid" style="background: transparent;">';
            html = html + '<iframe src="'+link+'" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="" style="width: '+width+'px; height: '+height+'px;"></iframe>';
            html = html + '</div>';
            $.fancybox.open(html);
        });

        // Read more links to collapse large text
        $('.read-more').each(function() {
            var $el = $(this),
                maxHeight = $el.data('max-height');
            if ( maxHeight == undefined || maxHeight * 1 < 1 ) {
                maxHeight = 250;
            }
            if ( $el.height() > maxHeight ) {
                var html = '<div class="inner" style="max-height: ' + maxHeight +'px;" data-height="' + $el.height() + '">' + $el.html();
                html += '<p class="expand"><a class="button">Read More</a></p></div>';
                $(this).html(html);
            }
        });
        $('.read-more').on('click', '.expand .button', function() {
            var $el = $(this).closest('.read-more').find('.inner'),
                targetHeight = $el.data('height');
            $el.animate( { maxHeight: targetHeight, marginBottom: 0 }, 300, function() {
                $el.find('.expand').fadeOut(100);
            });
        });

        // Virtual events description toggle
        $('.evs.top-filter-wrap li label').click(function() {
            setTimeout(function() {
                var index = $('.evs.top-filter-wrap li label.active').closest('li').index();
                if ( $('.evs.top-filter-wrap li label.active').length > 1 || index < 0 ) {
                    index = 0;
                }

                $('.evs.results-summary .description').hide();
                $('.evs.results-summary .description').eq(index).removeClass('hide').hide().fadeIn(200);
            }, 100);
        });
        $('.evs.top-filter-wrap li label:first').click();

        $('.tax_options input').on('change', function(){
            var target = $(this).parent().parent().parent().parent().find('button').removeAttr('disabled');
        });

        $('.tax_options select').on('change', function(){
            var target = $(this).parent().parent().parent().parent().find('button').removeAttr('disabled');
        });

        $('.vacancy-outer .show-filters').click(function(e) {
            e.preventDefault();
            $(this).fadeOut(200);
            $('.vacancy-search form').slideDown(200);
            return false;
        });

        // Vacancy form auto-populate
        if ( $('.vacancy-apply form, .reg-populate-form form').length > 0 ) {
            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: ajax_url,
                data: { 'action': 'user_reg_data' },
                success: function(form_data) {
                    if ( typeof(form_data) != 'object' ) {
                        return false;
                    }
                    $('.vacancy-apply form, .reg-populate-form form').find( 'input:visible, select:visible' ).each(function() {
                        var $input = $(this);
                        if ( $input.val() == '' ) {
                            var label = $input.closest('.gfield').find('.gfield_label').text().trim().replace('(Required)', '');
                            if ( typeof( form_data[label] ) != 'undefined' ) {
                                $input.val( form_data[label] );
                            }
                        }
                    });
                }
            });
        }
        // Vacancy form show/hide sub categories
        function filterVacancySubcats() {
            $('.subcat.dash-field .dash-input').show();
            var parentId = $('select[name="tax_vacancy_category"]:visible, select[name="tax_experience_category"]:visible').val();
            $('.subcat.dash-field').find('.ms-drop input[type="checkbox"]').each(function() {
                // Also always hide Select All
                if ( $(this).val().indexOf(parentId + '_') >= 0 ) {
                    $(this).closest('li').show();
                } else {
                    $(this).closest('li').hide();
                }
            });
        }
        if ( $('#vacancy_form, #experience_form').length > 0 ) {
            $('.subcat.dash-field .dash-input').hide();
            $('select[name="tax_vacancy_category"], select[name="tax_experience_category"]').change(function() {
                $('select[name="tax_vacancy_subcategory[]"], select[name="tax_experience_subcategory[]"]').val('');
                $('.ms-choice>span').text('');
                filterVacancySubcats();
            });
            $('.subcat.dash-field').find('.ms-drop input[type="checkbox"]').change(function() {
                filterVacancySubcats();
            });
            $('select[name="tax_vacancy_category"], select[name="tax_experience_category"]').change();
        }
        // Vacancy to email validation
        function validateVacancyEmail() {
            $('input[name="email_applications_to"]').removeClass('invalid');
            emailStr = $('input[name="email_applications_to"]').val();
            if ( emailStr.trim() == '' ) {
                return true;
            }
            if ( emailStr.indexOf(',') >= 0 ) {
                var emails = emailStr.split(',');
            } else {
                var emails = [ emailStr ];
            }
            for ( var i=0; i < emails.length; i++ ) {
                if ( !validateEmail( emails[i].trim() ) ) {
                    $('input[name="email_applications_to"]').addClass('invalid');
                    alert( 'Email "' + emails[i].trim() + '" invalid, please try again.' );
                    return false;
                }
            }
        }
        $('input[name="email_applications_to"]').change(function() {
            validateVacancyEmail();
        });
        $('#vacancy_form, #experience_form').submit(function(e) {
            if ( $('#vacancy_form, #experience_form').find('input.invalid').length > 0 ) {
                e.preventDefault();
                alert('Please correct form errors and try again.');
                return false;
            }
        });

        //init MAP with custom settings
        function initMap() {

            var $mapDiv = $('#map'),
                lat = $mapDiv.data('lat'),
                lan = $mapDiv.data('lan'),
                zoom = $mapDiv.data('zoom'),
                marker = $mapDiv.data('marker'),
                title = $mapDiv.data('title'),
                windowHeight = $( window ).height(),
                mapHeight =  (windowHeight/2) - 150;

            //set map height to half window height
            if (mapHeight<400) {
                mapHeight = 400;
            }

            $mapDiv.height(mapHeight);

            if($('body').hasClass('mobile')) {
                var optionNavigationControl = false,
                    optionTypeControl = false,
                    optionScaleControl = false,
                    optionDraggable = false,
                    optionScrollwheel = false;
            }
            else {
                var optionNavigationControl = false,
                    optionTypeControl = true,
                    optionScaleControl = true,
                    optionDraggable = true,
                    optionScrollwheel = false;
            }

            var myLatLng = {lat: lat, lng: lan};
            var map = new google.maps.Map(document.getElementById('map'), {
                zoom: zoom,
                // mapTypeId: google.maps.MapTypeId.SATELLITE,
                navigationControl: optionNavigationControl,
                mapTypeControl: optionTypeControl,
                scaleControl: optionScaleControl,
                draggable: optionDraggable,
                scrollwheel: optionScrollwheel,
                center: myLatLng
            });

            var markerImage = new google.maps.MarkerImage(marker,
                new google.maps.Size(41, 61), //size
                new google.maps.Point(0, 0), //origin point
                new google.maps.Point(20, 61)); // offset point

            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: markerImage,
                title: title
            });
        }

                if ($('#open-map').length>0) {
            initOpenStreetMap();
        }

        function initOpenStreetMap(){
            var mapHeight = getWindowHeight() * 0.4;
            if (mapHeight < 400) {
                mapHeight = 400;
            }

            $('#open-map').css( 'height', mapHeight);
            map = L.map('open-map').setView([omap.center_lat, omap.center_lng], omap.zoom);

            // add an OpenStreetMap tile layer
            var tile = L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
            });
            tile.addTo(map);
            addOpenMarkers();
        };

        function addOpenMarkers() {
            var markers = omap.markers;
            var imgUrl = $('#open-map').attr('data-marker');
            var mapIcons = [];
            mapIcons['st'] = L.icon({
                iconUrl: imgUrl,
                iconSize: [30, 50]
            });
/*            mapIcons['w'] = L.icon({
                iconUrl: imgUrl + 'status-s-w.png',
                iconSize: [20, 20]
            });
            mapIcons['wr'] = L.icon({
                iconUrl: imgUrl + 'status-s-wr.png',
                iconSize: [20, 20]
            });*/

            for (var i=0; i < markers.length; i++) {
                var lat = markers[i].lat,
                    lng = markers[i].lng,
                    markerTitle = markers[i].default_label;
                L.marker([ lat, lng ], {title: markerTitle, icon: mapIcons['st'] }).addTo(map);
            }
        }

        //click trigger
        function bindClick() {
            $('.clickTrigger').on('click', function(e) {
                e.preventDefault();
                var targetLine = $(this).data('target');
                var $target = $( targetLine);
                $target.trigger( "click" );
            });
        }

        $('.share-toggle').on('click', function(){
            $('.share-block').slideToggle();
        });

        $('body').on('click', '.copyToClipboard', function(e){
            e.preventDefault();
            $(this).html('<span class="icon-ok"></span>');
            element = $(this).data('target');
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val($(element).val()).select();
            document.execCommand("copy");
            $temp.remove();
        });

        function setupAutoComplete(){
            if ($('input.autoc').length>0) {
                $.each($('input.autoc'), function(){
                    var name = $(this).attr('name');
                    if (name != undefined && name != '') {
                        getComplete(name).then(function(data){
                        //    console.log(name +' AUTOC');
                         //   console.log(data);
                            var validOptions = decodeJSON(data);

                            $('input.autoc[name='+name+']').autocomplete({
                                autoFocus: true,
                                source: validOptions
                            }).keyup(function() {
                                var isValid = false;
                                for (i in validOptions) {
                                    if (validOptions[i].toLowerCase().match(this.value.toLowerCase())) {
                                        isValid = true;
                                    }
                                }
                                if (!isValid) {
                                    this.value = previousValue
                                } else {
                                    previousValue = this.value;
                                }
                            });

                        })
                    }
                });
            }
        }

        function getComplete(name) {
            return new Promise( function(resolve, reject) {
                $.ajax({
                    url: ajax_url,
                    type: 'GET',
                    data: {
                        'action': 'sc_tax_items',
                        'tax': name,
                    },
                    success: function (data) {
                        resolve(data)
                    },
                    error: function (error) {
                        reject(error)
                    },
                })
            })
        }

        function updateBodyContrasdtAndFont() {
            var contrast = getCookie('contrast');
            var fontSize = getCookie('font-size');
            if (contrast != '' && contrast != undefined && contrast != 'NaN') {
                $('body').addClass(contrast);
            }
            if (fontSize != '' && fontSize != undefined && fontSize != 'NaN') {
                $('body').addClass('f'+fontSize).attr('data-font', fontSize);

            }
            else {
                $('body').attr('data-font', 16);
            }
            $(window).trigger('resize');
        }

        function videoJSHeight() {
            if ($('.video-js[data-wratio]').length>0) {
                $.each($('.video-js'), function(){
                    var width = $(this).width(),
                        ratio = $(this).attr('data-wratio'),
                        height = width * ratio;
                    $(this).height(height);
                });
            }
        }

        function hadleBodyControls() {
            $('.wcag-btn').on('click', function(e) {
                e.preventDefault();
                var action = $(this).data('target');
                console.info('Action: '+action);

                if (action == 'night') {
                    $('body').removeClass('contrast-bw').addClass('contrast-night');
                    setCookie('contrast', 'contrast-night');
                }
                else if (action == 'bw') {
                    $('body').removeClass('contrast-night').addClass('contrast-bw');
                    setCookie('contrast', 'contrast-bw');
                }
                else if (action == 'reset-color') {
                    $('body').removeClass('contrast-night').removeClass('contrast-bw');
                    $.removeCookie('contrast', { path: '/' });
                }
                else if (action == 'plus') {
                    var current = $('body').attr('data-font'),
                        NewSize = parseInt(current) + 2;
                    if (NewSize > 22) {
                        NewSize = 22;
                    }
                    setCookie('font-size', NewSize);
                    $('body').removeClass('f'+current).addClass('f'+NewSize);
                    $('body').attr('data-font', NewSize);

                }
                else if (action == 'minus') {
                    var current = $('body').attr('data-font'),
                        NewSize = parseInt(current) - 2;
                    if (NewSize < 16) {
                        NewSize = 16;
                    }
                    setCookie('font-size', NewSize);
                    $('body').removeClass('f'+current).addClass('f'+NewSize);
                    $('body').attr('data-font', NewSize);
                }
                else if (action == 'reset-font') {
                    var current = $('body').attr('data-font');
                    $('body').removeClass('f'+current);
                    $.removeCookie('font-size', { path: '/' });
                }

            });
        }


        //Scroll to el if page has Hash
        if(window.location.hash) {
            var hash = window.location.hash;
            if ($(hash).length>0) {
                scrollToEl(hash, 220);
            }
        }

        //function scroll to element
        function scrollToEl(target, offset) {
            var $target = $(target);
            $("html, body").animate({ scrollTop: $target.offset().top - (offset + 70)}, 1000);
        }

        function updateWData() {
            wdata.ww = getWindowWidth();
            wdata.wh = getWindowHeight();
            wdata.scroll =  $(window).scrollTop();

            if (wdata.debug == true) {
                console.info('updateWData');
                console.log(wdata);
            }
        }

        function layoutBlockVis(){
            $.each($('.fc-row:not(:first)'), function() {
                if ( !$(this).hasClass('do-not-show') ) {
                    var id = $(this).attr('id');
                    if (isInViewPort('#'+id)) {
                        $('#'+id).removeClass('non-visible').addClass('is-visible');
                    }
                    else {
                        $('#'+id).addClass('non-visible').removeClass('is-visible');
                    }
                }
            });

            if ($('.fc-row.last-row').maxLength> 0) {
                if (isInViewPort('.fc-row.last-row')) {
                    $('footer.footer').removeClass('non-visible').addClass('is-visible');
                }
                else {
                    $('footer.footer').addClass('non-visible').removeClass('is-visible');
                }
            }
        }

        //window height
        function getWindowHeight() {
            return $( window ).height();
        }

        //window width
        function getWindowWidth() {
            return $( window ).width();
        }

        //validate Phone
        function validatePhone(phone) {
            var re = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
            return re.test(phone);
        }

        //validate Email
        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        function lazyBg(){
            var TopPos = $(window).scrollTop(),
                BottomPos = TopPos + $(window).height();
            var use = 'src';
            if (wdata.ww > 1200) {
                use = 'large';
            }
            $.each($('.lazy-bg.blur'), function() {
                var TopElement = $(this).offset().top,
                    BotElement = TopElement + $(this).height();
                if ((BotElement <= BottomPos) && (TopElement >= TopPos)) {
                    var imgSrc = $(this).attr('data-'+use);
                    if (imgSrc != undefined) {
                        $(this).attr('style', 'background-image: url('+imgSrc+');').removeClass('blur').addClass(use);
                    }
                }
            });
        }


        /* CHnage figure backgrounds on different screen sizes */
        function useLargeImages() {
            if (wdata.ww > 1366) {
                $.each($('.large-bg-image'), function(){
                    var large = $(this).attr('data-large');
                    if (large != undefined && large != '') {
                        $(this).attr('style', 'background-image: url('+large+');');
                    }
                });
            }
            else if (wdata.ww > 640) {
                $.each($('.large-bg-image'), function(){
                    var large = $(this).attr('data-src');
                    if (large != undefined && large != '') {
                        $(this).attr('style', 'background-image: url('+large+');');
                    }
                });
            }
        }

        //check if element is visible #element, .element
        function isElementVisible(elementToBeChecked) {
            var TopView = $(window).scrollTop();
            var BotView = TopView + $(window).height();
            var TopElement = $(elementToBeChecked).offset().top;
            var BotElement = TopElement + $(elementToBeChecked).height();
            return ((BotElement <= BotView) && (TopElement >= TopView));
        }

        function blockPositionsData(elementToBeChecked) {
            var TopView = $(window).scrollTop(),
                BotView = TopView + $(window).height(),
                TopElement = $(elementToBeChecked).offset().top,
                BotElement = TopElement + $(elementToBeChecked).height(),
                elementHeight = $(elementToBeChecked).height();
            var data = [];
            data.top = TopView;
            data.bottom = BotView;
            data.height = elementHeight;
            data.posTop = TopElement;
            data.posBottom = BotElement;
            return data;
        }

        function isInViewPort(elementToBeChecked) {
            var TopView = $(window).scrollTop();
            var BotView = TopView + $(window).height();
            var TopElement = $(elementToBeChecked).offset().top;
            var BotElement = TopElement + $(elementToBeChecked).height();
            var elementHeight = $(elementToBeChecked).height();
            var status = false;
            if ((TopView - (elementHeight+150)) < TopElement && BotView > (BotElement - elementHeight)) {
                status = true;
            }
            return status;
        }

        function svgSupport() {
            if (typeof SVGRect != "undefined") {
                $('body').addClass('svg');
                var status = true;
                $.each($('img'), function(){
                    var  svgVersion = $(this).attr('data-svg');
                    if (svgVersion != undefined && svgVersion != '') {
                        $(this).attr('src', svgVersion);
                    }
                });
            }
            else {
                $('body').addClass('no-svg');
                var status = false;
            }
            if (window.devicePixelRatio > 1.3) {
                $('body').addClass('retina');
            }
            return status;
        }

        /* Get Cookie */
        function getCookie(name) {
            var cookie = $.cookie(name);
            if (cookie == '') {
                cookie = false;
            }
            return cookie;
        }

        /* Set Cookie*/
        function setCookie(name, val, expires){
            if (expires == '' || expires == 'undefined') {
                var expires = 7;
            }
            $.cookie(name, val, { expires: expires, path: '/' });
            return true;
        }


        // Cookie notification message
        cookieAccept();
        function cookieAccept() {
            var cookieDiv = jQuery('.cookie-notice-container'),
                cookieButton = jQuery('.cn-set-cookie'),
                cookieName = jQuery('.cookie-notice-container').data('cname');
            accept = jQuery.cookie(cookieName);
            // console.log(cookieName);

            if (accept != 'accepted') {
                cookieDiv.show();
            }
            else {
                cookieDiv.hide();
            }

            cookieButton.on('click', function(e) {
                e.preventDefault();
                var cookieName = jQuery('.cookie-notice-container').data('cname');
                var cookieExpires = jQuery('.cookie-notice-container').data('expiration');
                jQuery.cookie(cookieName, 'accepted', { expires: cookieExpires, path: '/' });
                cookieDiv.hide();
            });
        }

        /* USER LOGIN start */
        $('form#login').on('submit', function(e){
            e.preventDefault();
            $('#login p.status').removeClass('alert');
            $('#login p.status').addClass('prg');
            $('form#login button[type=submit]').attr('disabled', 'disabled');
            $('form#login p.status').show().html('Trying login as <strong>'+$('form#login #username').val()+'</strong>');
            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: ajax_url,
                data: {
                    'action': 'ajaxlogin', //calls wp_ajax_nopriv_ajaxlogin
                    'username': $('form#login #username').val(),
                    'password': $('form#login #password').val(),
                    'g-recaptcha-response': $('form#login #g-recaptcha-response').val(),
                    'redirect': $('form#login #redirect').val(),
                    'stone_captcha': $('form#login #stone_captcha').val(),
                    'security': $('form#login #security').val() },
                success: function(data){
                    //     console.log(data);
                    $('form#login button[type=submit]').removeAttr('disabled');
                    $('form#login p.status').text(data.message);
                    if (data.loggedin == true){
                        // console.log('Redirect to '+data.redirect);
                        document.location.href = data.redirect;
                        $('#login p.status').addClass('success');
                        $('#login p.status').removeClass('prg');
                    }
                    else {
                        $('#login p.status').removeClass('prg');
                        $('#login p.status').addClass('alert');
                    }
                }
            });
            e.preventDefault();
        });
        $('form#login button[type=submit]').removeAttr('disabled');
        /* USER LOGIN end */

        if ($('#adr_postcode').length>0) {
            $('#adr_postcode').attr('minlength', 3);
            $('#adr_postcode').attr('maxlength', 4);
            $('#wppb-form-element-36').hide();
            wdata.postCode = null;
            $('#adr_postcode').on('change', function (){
                var pc = $(this).val();
                if (pc != '' && wdata.postCode != pc) {
                    updateCountyField(pc);
                }
            });
        }

        if ($('#wppb-register-user').length>0) {
            $.each($('#wppb-register-user select > option'), function(){
                var text = $(this).text();
                if (text == '') {
                    $(this).text(' - Please select - ').prop('disabled', true);
                }
            });
            var submitValue = $('#wppb-register-user #register').val();
            if (submitValue == 'Register') {
                $('#wppb-register-user #register').val('Create My Account');
            }
        }

        function updateCountyField(postcode){
            console.log('updateCountyField');
            if ($('#county').length>0) {
                $.get( 'https://nominatim.openstreetmap.org/search?countrycodes=gb&addressdetails=1&format=json&q=' + postcode + '%20England', function(results) {
                    var county = results[0].address.county;
                    console.log(county);
                    $('#county').val(county);
                });
            }
        };

        $('body').on('change', '#dob_field', function(e){
            var dob = $('#dob_field').val();

            if( xhr != null ) {
                xhr.abort();
                xhr = null;
            }

            xhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: "POST",
                cache: false,
                data: ({
                    action:'get_age',
                    dob: dob
                }),

                beforeSend: function() {
                    $('#wppb-form-element-26 .age_display').remove();
                    $('#wppb-form-element-26').addClass('has-age');
                    $('#wppb-form-element-26').append('<span class="age_display"></span>');
                },
                success: function( data ) {
                    $('#wppb-form-element-26').append('<span class="age_display">'+data+'</span>');
                    if (data > 5 && data < 14) {
                        registerForFields(false, true);
                    }
                    else if (data > 13) {
                        registerForFields(true, true);
                    }

                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        });

        if ($('#wppb-register-user').length>0 && $('#dob_field').length>0) {
            $('#wppb-register-user  #register').prop('disabled', true);
            registerForFields();
        }

        function registerForFields(status, btn) {
            var exclude = ["wppb-form-element-34"]
            if (status == true) { //show all fields
                $('.sc-required').remove();
                $.each($('#wppb-register-user li'), function(){
                    if (!$(this).find('.wppb-required').length>0) {
                        var id = $(this).attr('id');
                        if (!exclude.includes(id)) {
                            $(this).find('label').append('<span class="sc-required">*</span>');
                            $(this).find('input, select').prop('required', true);
                        }
                        $(this).show();
                    }
                });
            }
            else { // hide not required
                $('.sc-required').remove();
                $.each($('#wppb-register-user li'), function(){
                    if (!$(this).find('.wppb-required').length>0) {
                        $(this).find('label .sc-required').remove();
                        $(this).find('input, select').prop('required', false);
                        $(this).hide();
                    }
                });
            }
            if (btn == true) {
                $('#wppb-register-user  #register').prop('disabled', false);            }
            else {
                $('#wppb-register-user  #register').prop('disabled', true);
            }
            $('#wppb-form-element-36').hide();
        }

        function shopLayoutToggle(){
            if ($('.view-toggle .vtoggle').length>0) {
                var toggleStatus = getCookie('shop-view');
                if (toggleStatus == 'list') {
                    $('.vtoggle[data-style=list]').addClass('active');
                    $('body').addClass('list-view');
                }
                else {
                    $('.vtoggle[data-style=grid]').addClass('active');
                }
            }
            $('.vtoggle').on('click', function(e){
                e.preventDefault();
                var style = $(this).attr('data-style');
                $('.vtoggle').removeClass('active');
                setCookie('shop-view', style);
                if (style == 'list') {
                    $('body').addClass('list-view');
                }
                else {
                    $('body').removeClass('list-view');
                }
                $(this).addClass('active');
                setTimeout(function(){
                    $(window).trigger('resize');
                }, 500);
            });
        }

        $('.toggle-check').on('click', function(){
            var chboxCount = $(this).parent().find('input[type=checkbox]').length,
                chboxChecked = $(this).parent().find('input[type=checkbox]:checked').length;
            if (chboxCount == chboxChecked) {
                $(this).parent().find('input[type=checkbox]').prop( "checked", false );
            }
            else {
                $(this).parent().find('input[type=checkbox]').prop( "checked", true );
            }
            $(this).parent().find('button[type=submit]').prop( "disabled", false );
        });

        $('.tax_item_wrap > h5').on('click', function(){
            //.filter-item-toggle
            $(this).parent().toggleClass('active');
            $(this).parent().find('.tax_options').slideToggle();
        });

        $('.top-filter label').on('click', function(){
            var target = $(this).attr('for');
            if (target == 'type-all') {
                $('.top-filter label').removeClass('active');
                $(this).addClass('active');
                $('input[name="type[]"]').prop('checked', 'checked');
            }
            else {
                if ($('.top-filter label[for=type-all]').hasClass('active')) {
                    $('.top-filter label[for=type-all]').removeClass('active');
                    $('input[name="type[]"]').prop('checked', false);
                }
                setTimeout(function(){
                    $.each($('.invisible-options input'), function(){
                        var id = $(this).attr('id'),
                            name = $(this).attr('name');
                     //   console.log(name);
                        if (id != undefined && id != '' && $(this).is(':checked')) {
                            $('.top-filter label[for='+id+']').addClass('active');
                        }
                        else {
                            $('.top-filter label[for='+id+']').removeClass('active');
                        }
                    });
                }, 50);

            }
        });

        setTimeout(function(){
            $('.evs-sc-container form').on('change', function(e){
                $('button.trigger-search').removeClass('disabled');
            });
        }, 2000);

        $('button.trigger-search').on('click', function(e){
            e.preventDefault();
            if (!$(this).hasClass('disabled')) {
                $('.evs-sc-container form').trigger('submit');
            }
        });

        $('.evs-sc-container .type-options input[type=checkbox]').on('change', function(e){
            e.preventDefault();
            if (!$(this).hasClass('disabled')) {
                $('.evs-sc-container form').trigger('submit');
            }
        });

        $('.evp-ajax-nav .ajax-nav').on('click', function(e) {
            e.preventDefault();
            var current = parseInt($('.evp-ajax-nav').attr('data-current')),
                page = current;

            if ($(this).hasClass('prev')) {
                page = current - 1;
                if (current < 0) {
                    page = 0;
                }
            }
            else {
                page = current + 1;
                var total = parseInt($('.evp-ajax-nav').attr('data-total'));
                if (page > total) {
                    page = total;
                }
            }
            var ids = pages[page];
            if (ids != undefined && page != current) {
                getEvpPage(ids);
                $('.evp-ajax-nav').attr('data-current', page);
                $('#current_page').text(page + 1);
            }
        });

        var xhr = null;
        function getEvpPage(ids) {
            if( xhr != null ) {
                xhr.abort();
                xhr = null;
            }

            xhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: "POST",
                cache: false,
                data: ({
                    action:'get_evp_page',
                    ids: encodeJSON(ids)
                }),

                beforeSend: function() {
                    $('.load-more').addClass('active');
                },
                success: function( data ) {
                    $('#evs-results').html('<ul class="evp-list flex-display" data-equalizer >'+data+'</ul>');
                    $('.load-more').removeClass('active');
                    setTimeout(function(){
                        $('#evs-results').foundation();
                    }, 300);

                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }

        // Date Range picker Start
        if ($('#daterange').length>0) {
            if ( $('#daterange').hasClass('date-selected')) {
                var picker = $('#daterange').daterangepicker({
                    "parentEl": "#daterange-container",
                    "autoApply": true,
                    "startDate": $('#daterange').attr('date-start'),
                    "endDate": $('#daterange').attr('date-end'),
                    "minDate": $('#daterange').attr('date-min'),
                    "maxDate": $('#daterange').attr('date-max')
                });
            }
            else {
                var picker = $('#daterange').daterangepicker({
                    "parentEl": "#daterange-container",
                    "autoApply": true,
                    "minDate": $('#daterange').attr('date-min'),
                    "maxDate": $('#daterange').attr('date-max')
                });
                $('#daterange').val('');
            }
            $('.drp-calendar.right').hide();
            $('.drp-calendar.left').addClass('single');

            $('.calendar-table').on('DOMSubtreeModified', function() {
                var el = $(".prev.available").parent().children().last();
                if (el.hasClass('next available')) {
                    return;
                }
                el.addClass('next available');
                el.append('<span></span>');
            });

            // range update listener
            picker.on('apply.daterangepicker', function(ev, picker) {
             //   $("#daterangepicker-result").html('Selected date range: ' + picker.startDate.format('YYYY-MM-DD') + ' to ' + picker.endDate.format('YYYY-MM-DD'));
                $('#daterange').val(picker.startDate.format('YYYY-MM-DD')+':'+picker.endDate.format('YYYY-MM-DD'));
            });
            // prevent hide after range selection
            picker.data('daterangepicker').hide = function () {};
            // show picker on load
            picker.data('daterangepicker').show();
        }
        // Date Range picker End


        function forcePop(){
            if ($('body').hasClass('home') && !$('body').hasClass('logged-in')) {
                $('a.login-trigger').trigger('click');
            }
        }



        /* Heart Beat START */
        if ($('#has-heartbeat').length>0) {
            if (heartbeat != undefined && heartbeat != '') {
                wdata.hb = heartbeat;
                setTimeout(function(){
                    sendHeartBeat();
                }, 30000);
            }
        }

        function sendHeartBeat(){
            xhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: "POST",
                cache: false,
                data: ({
                    action:'sc_heart_beat',
                    options: wdata.hb,
                }),

                beforeSend: function() {
                },
                success: function( data ) {
                    setTimeout(function(){
                        sendHeartBeat();
                    }, 120000);
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }
        /* Heart Beat END */

        /* Calendar add/remove START */
        $('body').on('click', '.calendar-action', function(e){
            e.preventDefault();
            var option = $(this).attr('data-action'),
                pid = $(this).attr('data-pid');
            calendarAddRemove(option, pid);
        });

        function calendarAddRemove(option, pid) {
            if( xhr != null ) {
                xhr.abort();
                xhr = null;
            }

            xhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: "POST",
                cache: false,
                data: ({
                    action:'sc_calendar_book',
                    option: option,
                    pid: pid
                }),

                beforeSend: function() {
                   $('.calendar-controls').attr('style', 'opacity: 0.5;');
                },
                success: function( data ) {
                    if ($('.calendar-controls').length>0) {
                        $('.calendar-controls').attr('style', '');
                        $('.calendar-controls').html(data);
                    }
                    else {
                        $('.remove-from-booked[data-pid='+pid+']').remove();
                    }

                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }

        $('body').on('click', '.remove-from-booked', function(e){
            e.preventDefault();
            var option = $(this).attr('data-action'),
                pid = $(this).attr('data-pid');
            calendarAddRemove(option, pid);
        });
        /* Calendar add/remove END */

        /* Job add/remove START */
        $('body').on('click', '.heart-action', function(e){
            e.preventDefault();
            var option = $(this).attr('data-action'),
                pid = $(this).attr('data-pid');
            jobAddRemove(option, pid);
        });

        function jobAddRemove(option, pid) {
            if( xhr != null ) {
                xhr.abort();
                xhr = null;
            }

            xhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: "POST",
                cache: false,
                data: ({
                    action:'sc_vacancy_watch',
                    option: option,
                    pid: pid
                }),

                beforeSend: function() {
                   $('.heart-action[data-pid='+pid+']').attr('style', 'opacity: 0.5;');
                },
                success: function( data ) {
                    if ($('.heart-action[data-pid='+pid+']').length>0) {
                        $('.heart-action[data-pid='+pid+']').attr('style', '');
                        $('.heart-action[data-pid='+pid+']').parent().html(data);
                    }
                    else {
                        $('.remove-from-jobs[data-pid='+pid+']').remove();
                    }

                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }

        $('body').on('click', '.remove-from-jobs', function(e){
            e.preventDefault();
            var option = $(this).attr('data-action'),
                pid = $(this).attr('data-pid');
            jobAddRemove(option, pid);
        });
        /* Job add/remove END */

        /* Learning zone upload START */
        $('#submit-file').on('click', function(e){
            e.preventDefault();
            var data = $('#att-submit').serialize();
            renderAfterSubmit(data);
        });

        function renderAfterSubmit(data){
            xhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: "POST",
                cache: false,
                data: ({
                    action:'submit_and_render',
                    data: data
                }),

                beforeSend: function() {
                    $('#submit-file').addClass('disabled');
                },
                success: function( data ) {
                    $('.sc-file-upload').html(data);
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }

       // $('.submissions .extended button.expanded.review').on('click', function(e){
        $('body').on('click', '.submissions .extended button.expanded.review', function(e){
            e.preventDefault();
            var pid = $(this).attr('data-id');
            if (pid != undefined && pid != '') {
                reviewLearningRender(pid);
            }
        });

        $('body').on('change', '#event-name-select', function(e){
            var pid = $('#event-name-select').val();
            eventSubmitsRender(pid);

        });

        function eventSubmitsRender(pid) {
            xhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: "POST",
                cache: false,
                data: ({
                    action:'load_event_submits',
                    pid: pid
                }),

                beforeSend: function() {
                    $('.subs.extended').attr('style', 'opacity: 0.5');
                },
                success: function( data ) {
                    $('.lzone-ajax-render').html(data);
                    console.log(data);
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }

        function reviewLearningRender(pid){
            xhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: "POST",
                cache: false,
                data: ({
                    action:'review_learning_sub',
                    pid: pid
                }),

                beforeSend: function() {
                   $('.subs.extended').attr('style', 'opacity: 0.5');
                },
                success: function( data ) {
                    $('.subs.extended').attr('style', '');
                    $('#lzone_admin .reveal-content').html(data);
                    $('#lzone_admin').foundation('open');
                    bindLearningReview();
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }

        function collectFields(target = 'form') {
            var fieldsArr = {};
            $( target + " input[type=radio]" ).each(function( index ) {
                if($(this).attr("checked") == 'checked') {
                    var theValue = $(this).val();
                    var name = $(this).attr('name');
                    if (name == undefined || name== '') {
                        name = $(this).attr('id');
                    }
                    fieldsArr[name] = theValue;
                }
            });

            $( target + " input[type=checkbox]" ).each(function( index ) {
                if($(this).is(':checked')) {
                    var theValue = $(this).val();
                    var name = $(this).attr('name');
                    if (name == undefined || name== '') {
                        name = $(this).attr('id');
                    }
                    fieldsArr[name] = theValue;
                }
            });

            $( target + " select" ).each(function( index ) {
                if($(this).val() != '') {
                    var theValue = $(this).val();
                    var name = $(this).attr('name');
                    if (name == undefined || name== '') {
                        name = $(this).attr('id');
                    }
                    fieldsArr[name] = theValue;
                }
            });

            $( target + " textarea" ).each(function( index ) {
                if($(this).val() != '') {
                    var theValue = $(this).val();
                    var name = $(this).attr('name');
                    if (name == undefined || name== '') {
                        name = $(this).attr('id');
                    }
                    fieldsArr[name] = theValue;
                }
            });

            $( target + " input[type=number]" ).each(function( index ) {
                if($(this).val() != '') {
                    var theValue = $(this).val();
                    var name = $(this).attr('name');
                    if (name == undefined || name== '') {
                        name = $(this).attr('id');
                    }
                    fieldsArr[name] = theValue;
                }
            });

            $( target + " input[type=text]" ).each(function( index ) {
                if($(this).val() != '') {
                    var theValue = $(this).val();
                    var name = $(this).attr('name');
                    if (name == undefined || name== '') {
                        name = $(this).attr('id');
                    }
                    fieldsArr[name] = theValue;
                }
            });

            $( target + " input[type=email]" ).each(function( index ) {
                if($(this).val() != '') {
                    var theValue = $(this).val();
                    var name = $(this).attr('name');
                    if (name == undefined || name== '') {
                        name = $(this).attr('id');
                    }
                    fieldsArr[name] = theValue;
                }
            });

            $( target + " input[type=date]" ).each(function( index ) {
                if($(this).val() != '') {
                    var theValue = $(this).val();
                    var name = $(this).attr('name');
                    if (name == undefined || name== '') {
                        name = $(this).attr('id');
                    }
                    fieldsArr[name] = theValue;
                }
            });

            $( target + " input[type=hidden]" ).each(function( index ) {
                if($(this).val() != '') {
                    var theValue = $(this).val();
                    var name = $(this).attr('name');
                    if (name == undefined || name== '') {
                        name = $(this).attr('id');
                    }
                    fieldsArr[name] = theValue;
                }
            });

            $( target + " input[type=password]" ).each(function( index ) {
                if($(this).val() != '') {
                    var theValue = $(this).val();
                    var name = $(this).attr('name');
                    if (name == undefined || name== '') {
                        name = $(this).attr('id');
                    }
                    fieldsArr[name] = theValue;
                }
            });

            return fieldsArr;
        }

        function bindLearningReview(){
            $('#lreview').on('submit', function(e){
                e.preventDefault();
                var fields = collectFields('#lreview');
                if( xhr != null ) {
                    xhr.abort();
                    xhr = null;
                }
                xhr = $.ajax({
                    url: ajax_url,
                    timeout: 30000,
                    type: "POST",
                    cache: false,
                    data: ({
                        action:'review_attachment',
                        fields: fields
                    }),

                    beforeSend: function() {
                        $('#lreview').addClass('loading');
                        $("#lreview button").prop('disabled', true);
                    },
                    success: function( reply ) {
                        var data = decodeJSON(reply);
                        console.log(data);
                        var html = '<p>'+data.message+'</p>';
                        $('#lreview .status-msg').html(html);
                        $('#lreview').removeClass('loading');
                        $("#lreviewt button").prop('disabled', false);
                    },
                    error: function( jqXHR, textStatus, errorThrown ) {
                        console.log( 'The following error occured: ' + textStatus, errorThrown );
                        $("#lreview button").prop('disabled', false);
                    },
                    complete: function( jqXHR, textStatus ) {
                    }
                });
            });
        }

        if (window['sc_alert_fields'] != undefined) {
            var fieldsArr = window['sc_alert_fields'];
            $.each(fieldsArr, function(k,f){
                if ($('[name='+f+']').length>0) {
                    $('[name='+f+']').addClass('alert');
                    $('[name='+f+']').on('change', function(){
                        $(this).removeClass('alert');
                    });
                }
            });
        }

        if (window['sc_hide_user_fields'] != undefined) {
            if (window['sc_hide_user_fields'] == true) {
                $.each($('.wppb-edit-user li'), function(){
                    if (!$(this).find('.wppb-required').length>0) {
                        $(this).hide();
                    }
                });
            }
        }

        function bindIntMap(){
            if ($('.int-map-wrap').length>0 && window['int_pops'] != undefined) {
                wdata.brPops = window['int_pops'];
                $('svg path, svg polygon').on('click', function(){
                    var id = $(this).attr('data-tab');
                    if (id != undefined) {
                        var pops = wdata.brPops;
                        if (pops[id] != undefined) {
                            var record = pops[id];
                            $('.int-map-wrap .brpop').remove();
                            $('svg path').removeClass('active-area');
                            $('svg polygon').removeClass('active-area');
                            var html = '<div class="brpop" style="top: '+record['top']+'%; left: '+record['left']+'%;">';
                            html = html + '<div class="bgpop-content '+record['id']+'"><h5 class="pop-title">'+record['title']+'</h5><div class="pop-content">'+record['content']+'</div></div>';
                            html = html + '<span class="close-mpop icon-cancel-circled" title="Close"></span>';
                            html = html + '</div>';
                            $('+'+id).addClass('active-area');
                            $('.int-map').append(html);

                        }
                    }
                });
                $('body').on('click', '.close-mpop', function(){
                    $('.int-map-wrap .brpop').remove();
                    $('.map-wrap .brpop').remove();
                });
                $('svg path, svg polygon').on('mouseover', function(){
                    var id = $(this).attr('data-tab');
                    if (id != undefined) {
                        var pops = wdata.brPops;
                        if (pops[id] != undefined) {
                            var record = pops[id];
                            console.log(record);
                        }
                        $('.int-map .hover-hint').remove();
                        $('.int-map').append('<span class="hover-hint">'+record.title+'</span>');
                    }
                });
                $('svg path, svg polygon').on('mouseout', function(){
                    $('.int-map .hover-hint').remove();
                });
            }

            if ($('.map-wrap').length>0 && window['int_pops'] != undefined) {
                wdata.brPops = window['int_pops'];
                $('svg path, svg polygon').on('click', function(){
                    var id = $(this).attr('data-tab');
                    if (id != undefined) {
                        var pops = wdata.brPops;
                        if (pops[id] != undefined) {
                            var record = pops[id];
                            $('.map-wrap .brpop').remove();
                            $('svg path').removeClass('active-area');
                            $('svg attr').removeClass('active-area');
                            var html = '<div class="brpop" style="top: '+record['top']+'%; left: '+record['left']+'%;">';
                            html = html + '<div class="bgpop-content '+record['id']+'"><h5 class="pop-title">'+record['title']+'</h5><div class="pop-content">'+record['content']+'</div></div>';
                            html = html + '<span class="close-mpop icon-cancel-circled" title="Close"></span>';
                            html = html + '</div>';
                            $('+'+id).addClass('active-area');
                            $('.map-wrap').append(html);

                        }
                    }
                });
                $('body').on('click', '.close-mpop', function(){
                    $('.int-map-wrap .brpop').remove();
                    $('.map-wrap .brpop').remove();
                });
            }
        }


        function initVacanciesSearch(){
            if ($('#vsearch-results').length>0 && $('#vsearch-results').html() == '') {
                vacanciesSearch();
            }
        }

        $('#vacancies-search-form').on('change', function(){
            vacanciesSearch();
        });

        function vacanciesSearch(){
            if( xhr != null ) {
                xhr.abort();
                xhr = null;
            }
            var fields = $('#vacancies-search-form').serializeArray();

            xhr = $.ajax({
                url: ajax_url,
                timeout: 30000,
                type: "POST",
                cache: false,
                data: ({
                    action:'vsearch',
                    fields: fields
                }),

                beforeSend: function() {
                    $('.vsearch-results').addClass('loading');
                },
                success: function( html ) {
                    $('#vsearch-results').html(html);
                    $('.vsearch-results').removeClass('loading');
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                    $("#lreview button").prop('disabled', false);
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }
        /* Learning zone upload END */


        $('.desktop-nav > ul > li > a').mouseover(function(){
            var width = $(this).width(),
                offset = $(this).offset();
            $('.h-bottom-line').attr('style', 'width: '+width+'px; left: '+(offset.left +25)+'px;');
        });
        $('.desktop-nav > ul').mouseleave(function(){
            $('.h-bottom-line').attr('style', '');
        });

        /* Apprenticeship Ambassador START */
        $('#aa-submit').on('click', function(e){
            e.preventDefault();
            var data = $('#att-submit').serialize();
            insertAmbassadorUpload(data);
        });

        function insertAmbassadorUpload(data){
            xhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: "POST",
                cache: false,
                data: ({
                    action:'ambassador_upload',
                    data: data
                }),

                beforeSend: function() {
                    $('#aa-submit').addClass('disabled');
                },
                success: function( data ) {
                    console.log(data);
                    $('#pid, #att, #newname, #description').val('');
                    $('.att-details').html('');
                    renderAmbassadorUploads();
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }

        function removeAmbassadorUpload(att_id){
            xhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: "POST",
                cache: false,
                data: ({
                    action:'remove_ambassador_upload',
                    att: att_id
                }),

                beforeSend: function() {
                },
                success: function( data ) {
                    console.log(data);
                    renderAmbassadorUploads();
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }

        function renderAmbassadorUploads(){
            if ($('#ambassador-uploads').length>0) {
                // console.log('renderAmbassadorUploads');
                xhr = $.ajax({
                    url: ajax_url,
                    timeout: 12000,
                    type: "GET",
                    cache: false,
                    data: ({
                        action:'get_ambassador_uploads',
                    }),

                    beforeSend: function() {
                    },
                    success: function( data ) {
                        // console.log(data);
                        var tdata = decodeJSON(data)
                        if(tdata.length> 0) {
                            $('#ambassador-uploads').html('<table id="aaups"><thead><tr><td>Title</td><td>Description</td><td>Added</td><td>Type</td><td>Author</td><td>Actions</td></tr></thead></table>');
                            $('#aaups').DataTable( {
                                lengthMenu: [[ 25, 50, 100, -1], [25, 50, 100, "All"]],
                                pageLength: 50,
                                data: tdata,
                                columns: [
                                    { data: 'title' },
                                    { data: 'description' },
                                    { data: 'added' },
                                    { data: 'type' },
                                    { data: 'author' },
                                    { data: 'actions' }
                                ]
                            } );
                        }
                        else {
                            $('#ambassador-uploads').html('');
                        }
                        setTimeout(renderAmbassadorUploads, 60000);
                    },
                    error: function( jqXHR, textStatus, errorThrown ) {
                        console.log( 'The following error occured: ' + textStatus, errorThrown );
                    },
                    complete: function( jqXHR, textStatus ) {
                    }
                });
            }
        }

        $('body').on('click', '.deleteAttachment', function(e){
            e.preventDefault();
            var attachmentID = $(this).attr('data-attachment'),
                fileName = $(this).attr('data-ftitle');
            if (attachmentID != undefined && fileName != '') {
                var msg = 'Are you sure you want to DELETE "'+fileName+'"?';
                var answer = window.confirm(msg);
                if (answer) {
                    removeAmbassadorUpload(attachmentID);
                }
                else {

                }
            }
        });
        /* Apprenticeship Ambassador END */


        //Document Ready ENDS
    });
})(jQuery);


/* Array to JSON */
function encodeJSON(fields) {
    var jsonLine = JSON.stringify(fields);
    return jsonLine;
}

/* JSON to array */
function decodeJSON(string) {
    var array = jQuery.parseJSON(string);
    return array;
}